import { useRentalManagerUserPropertyMultiplexWebApiHandler_create } from '@zg-rentals/ts-rental-manager-api-client-react-query';

import { CREATE_LISTING_MUTATION_INVALIDATES } from '../../../constants/InvalidateConstants';

export const useMultiplexCreateUnits = () =>
  useRentalManagerUserPropertyMultiplexWebApiHandler_create({
    meta: {
      invalidates: [...CREATE_LISTING_MUTATION_INVALIDATES],
      context: { api: 'RentalManagerUserPropertyMultiplexWebApiHandler', details: 'useMultiplexCreateUnits' },
    },
  });
